/*
 *
 * Selectors for GiftCardsList
 *
 */

import { createSelector } from 'reselect';
const selectGiftCardsListDomain = (state) => state.get('giftCardsList');
const selectGiftCardsList = () => createSelector(
  selectGiftCardsListDomain,
  (GiftCardsList) => GiftCardsList,
);

const selectCategoryList = () => createSelector(
  selectGiftCardsListDomain,
  (GiftCardsList) => GiftCardsList.get('categoryList').toJS(),
);

const discountList = () => createSelector(
  selectGiftCardsListDomain,
  (GiftCardsList) => GiftCardsList.get('discountList').toJS(),
);

const brandList = () => createSelector(
  selectGiftCardsListDomain,
  (GiftCardsList) => GiftCardsList.get('brandList').toJS(),
);

const giftCardList = () => createSelector(
  selectGiftCardsListDomain,
  (GiftCardsList) => GiftCardsList.get('giftCardList').toJS(),
);

const getGiftCardClientId = () => createSelector(
  selectGiftCardsListDomain,
  (GiftCardsList) => GiftCardsList.get('giftcards_clientid'),
);

const selectGiftCardJS = (key) => createSelector(
  selectGiftCardsListDomain,
  (GiftCardsList) => GiftCardsList.get(key).toJS(),
);

export {
  selectGiftCardsList,
  selectCategoryList,
  discountList,
  brandList,
  giftCardList,
  getGiftCardClientId,
  selectGiftCardJS,
};



// WEBPACK FOOTER //
// client/containers/GiftCardsList/selectors.js